var _rect, _rect2, _rect3, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFa(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fa",
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 512,
    height: 511.989,
    transform: "translate(0 0.006)",
    fill: "#f0f0f0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 512,
    height: 170.663,
    fill: "#6da544"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    width: 512,
    height: 170.663,
    transform: "translate(0 341.337)",
    fill: "#d80027"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 22.261,
    height: 30.049,
    transform: "translate(44.522 155.826)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 22.261,
    height: 30.049,
    transform: "translate(0 155.826)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 22.261,
    height: 30.049,
    transform: "translate(89.043 155.826)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 22.261,
    height: 30.049,
    transform: "translate(133.565 155.826)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 22.261,
    height: 30.049,
    transform: "translate(178.087 155.826)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 22.261,
    height: 30.049,
    transform: "translate(222.609 155.826)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 22.261,
    height: 30.049,
    transform: "translate(267.13 155.826)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 22.261,
    height: 30.049,
    transform: "translate(311.652 155.826)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 22.261,
    height: 30.049,
    transform: "translate(356.174 155.826)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 22.261,
    height: 30.049,
    transform: "translate(400.696 155.826)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 22.261,
    height: 30.049,
    transform: "translate(445.217 155.826)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    width: 22.261,
    height: 30.049,
    transform: "translate(489.739 155.826)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 22.261,
    height: 29.492,
    transform: "translate(44.522 326.678)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 22.261,
    height: 29.492,
    transform: "translate(0 326.678)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    width: 22.261,
    height: 29.492,
    transform: "translate(89.043 326.678)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64",
    "data-name": "Rectangle 64",
    width: 22.261,
    height: 29.492,
    transform: "translate(133.565 326.678)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    width: 22.261,
    height: 29.492,
    transform: "translate(178.087 326.678)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    width: 22.261,
    height: 29.492,
    transform: "translate(222.609 326.678)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67",
    "data-name": "Rectangle 67",
    width: 22.261,
    height: 29.492,
    transform: "translate(267.13 326.678)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    width: 22.261,
    height: 29.492,
    transform: "translate(311.652 326.678)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69",
    "data-name": "Rectangle 69",
    width: 22.261,
    height: 29.492,
    transform: "translate(356.174 326.678)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70",
    "data-name": "Rectangle 70",
    width: 22.261,
    height: 29.492,
    transform: "translate(400.696 326.678)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    width: 22.261,
    height: 29.492,
    transform: "translate(445.217 326.678)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 22.261,
    height: 29.492,
    transform: "translate(489.739 326.678)",
    fill: "#f0f0f0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M319.746,204.8H294.067c.213,2.822.333,5.669.333,8.534,0,18.986-4.745,37.388-13.018,50.488-2.552,4.04-6.841,9.746-12.582,13.6V204.8H243.2v72.615c-5.74-3.849-10.03-9.553-12.582-13.6-8.273-13.1-13.018-31.5-13.018-50.488,0-2.864.121-5.712.333-8.534H192.254q-.247,4.212-.254,8.534c0,52.636,28.112,93.866,64,93.866s64-41.23,64-93.866Q320,209.012,319.746,204.8Z",
    fill: "#d80027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFa);
export default __webpack_public_path__ + "static/media/fa.7053610399bf3f259912bf95fcc9cc87.svg";
export { ForwardRef as ReactComponent };